import React from 'react';
import cancelImage from '../../../assets/images/cancelIcn.svg'
import Button from '../../../components/atoms/Button';
import styles from './style.module.css';
import { useNavigate } from "react-router-dom";
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import logo from "../../../assets/images/report.svg"

const ReportMsgBox = ({title1,title2}) => {
    const trackdata = useSelector((store) => store?.awbReducer?.data);
    console.log(trackdata,"url")
    const awb=trackdata?.shipmentDetails?.awbnumber;
    console.log(awb,"url")
    const navigate = useNavigate();
    const param  = useParams() 
    console.log(`/${awb}/modifyorder`,"url")
    const relodandNavigate = () => {
        console.log(`/${param.awbInfo}/`,"url")
        
        navigate(`/${param.awbInfo}/`)
     window.location.reload(true)
    }
    return (
        <div className = {styles.msgStyle}>
            <img src = {logo} alt = {"SuccessMsg"} />
            <div className = {styles.title1}>Issue Reported</div>
            <div className = {styles.title2}>We apologise for any inconvenience and will</div>
            <div className = {styles.title3}> work to resolve your issue quickly</div>
             <div>
            <Button  width={"30vh"} onclick={() => relodandNavigate()}
              height={"5vh"}  text = {"Go to Home"}  backgroundColor = {"#0075FF"} border = {"none"} color = {"#fff"}  ></Button>
        </div>
        </div>
    )
}

export default ReportMsgBox
